import script from "./DatabasetView.vue?vue&type=script&setup=true&lang=js"
export * from "./DatabasetView.vue?vue&type=script&setup=true&lang=js"

import "./DatabasetView.vue?vue&type=style&index=0&id=3d3550a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d3550a5"]])

export default __exports__